export default {
  // 部门跟树
  getDeptTop: "/wxapi/contact/list_top_departments",
  // 超过二级的部门树
  getDept: " /wxapi/contact/list_sub_departments",
  // 根据部门id获取人员:该项目不使用
  getUserByDeptId: "/index.php?model=summary&m=contact&a=get_user_tree",
  // 分组列表:该项目不使用
  getGroupList: "/index.php?model=summary&m=contact&a=get_group_tree",
  // 根据分组id获取人员:该项目不使用
  getUesrByGroupId: "/index.php?model=summary&m=contact&a=get_user_by_group",
  // 获取初始换数据
  getInitData: "/wxapi/contact/id_to_name",
  // 查询接口
  getSearchData: "/wxapi/contact/search"
};
